export const getAPIPath = (path: string) => {
  return new URL(path, process.env.REACT_APP_EVIL_API_URL).toString();
};
// The location where we will contact the EVIL API at
// export const API_URL = isProduction() ? "https://mapi.prd.evmng.valuespaces.io/" : "https://mapi.dev.evmng.valuespaces.io/"
